import { ListItem, TokenIcon } from '@/components';
import { TokenInterface } from '@/interfaces';
import {
  formatNumberToAmountInTokenCurrencyString,
  formatNumberToAmountInUsdString,
} from '@/utils/formatUtils';
import { FC } from 'react';
interface AmountListItemProps {
  amount: number;
  subAmount: number;
  token?: TokenInterface;
  symbol?: string;
}
const AmountListItem: FC<AmountListItemProps> = ({
  token,
  amount,
  subAmount,
  symbol = '',
}) => {
  return (
    <ListItem
      mainText={formatNumberToAmountInTokenCurrencyString(amount, symbol)}
      subText={formatNumberToAmountInUsdString(subAmount)}
      leftIcon={
        token ? (
          <TokenIcon
            token={token}
            tokenSymbol={token.symbol || ''}
            alt={token.name || ''}
          />
        ) : (
          <TokenIcon tokenSymbol={symbol} alt={symbol} />
        )
      }
      align="right"
    />
  );
};
export default AmountListItem;
